// Parcel products (Verzendopties) that a carrier only supports when a setting in its carrier settings is enabled.
// Enabling the setting checks the product for that carrier, disabling it unchecks it again.
const CARRIER_SETTING_PRODUCTS: {carrier: string, setting: 'signedEnabled' | 'signedLetterEnabled', product: string}[] = [
    {carrier: 'DHL', setting: 'signedEnabled', product: 'Aangetekend'},
    {carrier: 'DHL', setting: 'signedLetterEnabled', product: 'Aangetekende brief'},
    {carrier: 'DHL-europlus', setting: 'signedEnabled', product: 'Aangetekend'},
    {carrier: 'DHL-MSG', setting: 'signedEnabled', product: 'Aangetekend'},
    {carrier: 'DHL-MSG', setting: 'signedLetterEnabled', product: 'Aangetekende brief'},
    {carrier: 'DHL-QLS', setting: 'signedEnabled', product: 'Aangetekend'},
    {carrier: 'PostNL-MSG', setting: 'signedEnabled', product: 'Aangetekend'},
    {carrier: 'PostNL-MSG', setting: 'signedLetterEnabled', product: 'Aangetekende brief'},
    {carrier: 'PostNL-QLS', setting: 'signedEnabled', product: 'Aangetekend'},
    {carrier: 'PostNL-QLS', setting: 'signedLetterEnabled', product: 'Aangetekende brief'},
    {carrier: 'PostNL-onlineparcel', setting: 'signedEnabled', product: 'Aangetekend'}
]

type Products = Record<string, Record<string, boolean>>

// The carrier setting a product of the carrier depends on, if any
function carrierProductSetting(carrierName: string, product: string) {
    return CARRIER_SETTING_PRODUCTS.find((entry) => entry.carrier === carrierName && entry.product === product)?.setting
}

/**
 * Checks the products of the carrier whose setting is enabled and unchecks those whose setting is disabled or
 * missing. With onlyUncheck nothing is checked. Only the column of the carrier itself changes. Returns the products
 * that changed.
 */
function updateCarrierSettingProducts(products: Products, carrierName: string, carrierSettings: Record<string, unknown> | undefined, onlyUncheck = false): string[] {
    const changed: string[] = []

    CARRIER_SETTING_PRODUCTS.filter((entry) => entry.carrier === carrierName).map(({setting, product}) => {
        const enabled = !!carrierSettings?.[setting]

        if (enabled && !onlyUncheck && !products[product]?.[carrierName]) {
            products[product] = products[product] || {}
            products[product][carrierName] = true
            changed.push(product)
        }

        if (!enabled && products[product]?.[carrierName]) {
            products[product][carrierName] = false
            changed.push(product)
        }
    })

    return changed
}

export {CARRIER_SETTING_PRODUCTS, carrierProductSetting, updateCarrierSettingProducts}
